import { SVGProps } from "react";

export default function StepIcon3(props: SVGProps<SVGSVGElement>) {
  return (
<svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.33398 5L10.834 2.5M10.834 2.5L13.334 5M10.834 2.5L10.834 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M7.08398 7.5V7.5C5.01292 7.5 3.33398 9.17893 3.33398 11.25L3.33398 13.5C3.33398 15.7091 5.12485 17.5 7.33398 17.5L14.334 17.5C16.5431 17.5 18.334 15.7091 18.334 13.5L18.334 11.25C18.334 9.17893 16.6551 7.5 14.584 7.5V7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
 );
};
